<template>
  <gc-main-layout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :baseView="baseView"
    :key="baseView.mode"
    :backButtonEnable="true"
    :backButtonFunction="backButtonFunction"
    :formsConfig="formsConfig"
  >
    <template #headerContent>
      <GcHeaderContentStatic :title="reportTitle" v-if="reportTitle" />
    </template>

    <div class="grid-report">
      <gc-filter-split-view
        :showLeftContainer="showLeftContainer"
        :showRightContainer="showRightContainer"
      >
        <template #leftContent>
          <dx-data-grid
            :data-source="dataSourceConfig"
            :allow-column-reordering="true"
            :reshape-on-push="true"
            :columns="columns"
            @toolbar-preparing="onToolbarPreparing($event)"
            :height="gridHeight"
            v-if="loadingCompleted"
            @content-ready="listContentReady"
            ref="grid-report-grid"
            @exporting="onGridToExcelExporting($event, saveFileName, columns)"
            @cellPrepared="onCellPrepared($event, columnSummary)"
          >
            <DxExport :enabled="true" />
            <DxGroupPanel :visible="true" />
            <DxGrouping :auto-expand-all="false" />

            <DxSummary
              v-if="columnSummary"
              :calculate-custom-summary="calculateCustomSummary"
            >
              <DxGroupItem
                v-for="item in columnSummaryWithColumns"
                :key="item['id']"
                :column="item['column']"
                :summary-type="item['summary-type']"
                :value-format="item['value-format']"
                :display-format="item['display-format']"
                :show-in-group-footer="item['show-in-group-footer']"
                :align-by-column="item['align-by-column']"
                :show-in-column="item['show-in-column']"
              />
              <DxGroupItem
                v-for="item in columnSummaryCustom"
                :name="item['name']"
                :key="item['id']"
                :summary-type="item['summary-type']"
                :value-format="item['value-format']"
                :show-in-group-footer="item['show-in-group-footer']"
                :align-by-column="item['align-by-column']"
                :show-in-column="item['show-in-column']"
              />
            </DxSummary>

            <template #customer-group-cell-template="{ data }">
              <GcDescriptionCodeCellTemplate
                :description="data.data.CustomerGroupDescription"
                :code="data.data.CustomerGroupCode"
              />
            </template>

            <template #customer-type-cell-template="{ data }">
              <GcDescriptionCodeCellTemplate
                :description="data.data.CustomerTypeDescription"
                :code="data.data.CustomerTypeCode"
              />
            </template>

            <template #customer-cell-template="{ data }">
              <GcDescriptionCodeCellTemplate
                :description="data.data.CustomerName"
                :code="data.data.CustomerCode"
              />
            </template>

            <template #branch-cell-template="{ data }">
              <GcDescriptionCodeCellTemplate
                :description="data.data.BranchDescription"
                :code="data.data.BranchCode"
              />
            </template>

            <template #category-1-cell-template="{ data }">
              <GcDescriptionCodeCellTemplate
                :description="data.data.ProductCategory1Description"
                :code="data.data.ProductCategory1Code"
              />
            </template>

            <template #category-2-cell-template="{ data }">
              <GcDescriptionCodeCellTemplate
                :description="data.data.ProductCategory2Description"
                :code="data.data.ProductCategory2Code"
              />
            </template>

            <template #category-3-cell-template="{ data }">
              <GcDescriptionCodeCellTemplate
                :description="data.data.ProductCategory3Description"
                :code="data.data.ProductCategory3Code"
              />
            </template>

            <template #category-4-cell-template="{ data }">
              <GcDescriptionCodeCellTemplate
                :description="data.data.ProductCategory4Description"
                :code="data.data.ProductCategory4Code"
              />
            </template>

            <template #sales-rep-cell-template="{ data }">
              <GcDescriptionCodeCellTemplate
                :description="data.data.SalesRepresentativeFullName"
                :code="data.data.SalesRepresentativeCode"
              />
            </template>
            <template #customer-rep-cell-template="{ data }">
              <GcDescriptionCodeCellTemplate
                :description="data.data.CustomerSalesRepresentativeFullName"
                :code="data.data.CustomerSalesRepresentativeCode"
              />
            </template>
            <template #item-cell-template="{ data }">
              <GcDescriptionCodeCellTemplate
                :description="data.data.ItemDescription1"
                :code="data.data.ItemCode"
              />
            </template>

            <template #product-type-cell-template="{ data }">
              <GcDescriptionCodeCellTemplate
                :description="data.data.ProductTypeDescription"
                :code="data.data.ProductTypeCode"
              />
            </template>

            <template #product-size-cell-template="{ data }">
              <GcDescriptionCodeCellTemplate
                :description="data.data.ProductSizeDescription"
                :code="data.data.ProductSizeCode"
              />
            </template>

            <template #groupHeaderTemplate="{ data }">
              <div class="informer">
                <span>{{ data.displayValue }}</span>
              </div>
            </template>

            <template #group-dategroupdisplay-cell-template="{ data }">
              <div class="informer">
                <span>{{ formatGroupDateGroupDisplay(data) }}</span>
              </div>
            </template>

            <template #dategroupdisplay-cell-template="{ data }">
              <div>
                <span>{{
                  formatDateGroupDisplay(data.data.DateGroupDisplay)
                }}</span>
              </div>
            </template>

            <template #number-cell-template="{ data }">
              <!-- <div>
                <span v-if="data.value < 0" class="avail-error">{{
                  "(" + data.text.replace(/[-]/, "") + ")"
                }}</span>
                <span v-if="data.value > 0">{{ data.text }}</span>
                <span v-if="data.value == 0">{{ "-" }}</span>
              </div> -->
              <gc-grid-value-format :dataValue="data" />
            </template>
          </dx-data-grid>
        </template>

        <template #rightContent>
          <gc-advance-filter-panel
            :toolbar="filterToolbar"
            :setFilterFormHeight="filterFormHeight"
            :advanceFilterArray="advanceFilterArray"
            :filterCallBack="createFilterArray"
            :sideBarTabs="sideBarTabs"
            :filterFormItems="filterFormItems"
            :filterModel="getAdvanceFilterModel"
            :isJson="false"
            :screenType="'invoice-sales'"
            :applyFilter="applyFilter"
            :dirty.sync="filterDirty"
          >
          </gc-advance-filter-panel>
        </template>
      </gc-filter-split-view>
    </div>
  </gc-main-layout>
</template>

<script>
let salesExTaxValue = 0,
  grossProfitValue = 0;
import BaseViewMixin from "../../v1/_mixins/base.view";
import { GridReportService } from "../../_services/api/reports/grid-report.service";
import {
  DxSummary,
  DxGroupItem,
  DxExport,
  DxGrouping,
  DxGroupPanel,
} from "devextreme-vue/data-grid";

export default {
  props: {},
  mixins: [BaseViewMixin],
  components: {
    DxExport,
    DxGrouping,
    DxSummary,
    DxGroupItem,
    DxGroupPanel,
  },
  data() {
    return {
      advanceFilterArray: [],
      serverSideFilter: [],
      jsonData: undefined,
      jSonDataItems: undefined,
      reportTitle: "Invoiced Sales",
      dataSourceConfig: [],
      showLeftContainer: true,
      showRightContainer: false,
      filterDirty: { isDirty: false },
      filterToolbar: {
        close: {
          icon: "showpanel",
          onClick: () => {
            this.showRightContainer = !this.showRightContainer;
            var item = document.getElementById("filter-btn");
            item.classList.remove("dx-state-invisible");
          },
        },
      },
      // filterFormHeight: "auto",
      sideBarTabs: [
        {
          id: 0,
          text: "Filters",
        },
      ],
      saveFileName: "Invoiced Sales",
      filterByDate: false,
      apiRouteUrl: {
        url: "api/ReportInvoicedSales",
        filter: [["DateGroup", "=", "Day"]],
        // top: 50
      },
      loaded: false,
      //   columnSummary: undefined,
      advanceFilterModel: {
        DateGroup: "Day",
        DateIn: new Date(),
        // WeekStartDate: undefined,
        // FiscalPeriodId: undefined,
        SalesRepresentativeCode: [],
        CustomerSalesRepresentativeCode: [],
      },
      model: {
        StartWeekDisplay: undefined,
        CurrentDateGroup: undefined,
      },
      applyServerFilter: true,
    };
  },
  async created() {
    this.getCompanyDefaults();
    this.showLoading(true);
    await this.getDefaultValue();
    this.getReportData([]);
  },
  methods: {
    calculateCustomSummary(options) {
      // Calculating "customSummary1"
      if (options.name == "gppercent") {
        switch (options.summaryProcess) {
          case "start":
            // Initializing "totalValue" here
            salesExTaxValue = 0;
            grossProfitValue = 0;
            options.totalValue = 0;
            break;
          case "calculate":
            salesExTaxValue += options.value.SalesExTax;
            grossProfitValue += options.value.GrossProfitVal;
            // Modifying "totalValue" here
            break;
          case "finalize":
            // Assigning the final value to "totalValue" here
            options.totalValue = (grossProfitValue / salesExTaxValue) * 100;
            break;
        }
      }

      // Calculating "customSummary2"
      if (options.name == "customSummary2") {
        // ...
        // Same "switch" statement here
      }
    },

    formatDateGroupDisplay(value) {
      if (
        this.model.CurrentDateGroup == "Day" ||
        this.model.CurrentDateGroup == "Week"
      ) {
        let data = value.match(/.{1,2}/g);
        // console.log('value ', value);
        if (data.length == 4)
          return new Date(
            data[0].concat(data[1]) + "-" + data[2] + "-" + data[3]
          ).toShortDateString();
      } else if (this.model.CurrentDateGroup == "Month") {
        return value.split(":")[1].toProperCase();
      }
      return value.toProperCase();
    },
    formatGroupDateGroupDisplay(value) {
      if (
        this.model.CurrentDateGroup == "Day" ||
        this.model.CurrentDateGroup == "Week"
      ) {
        let data = value.displayValue.match(/.{1,2}/g);
        // console.log('value ', value);
        if (data.length == 4)
          return new Date(
            data[0].concat(data[1]) + "-" + data[2] + "-" + data[3]
          ).toShortDateString();
      } else if (
        this.model.CurrentDateGroup == "Month" &&
        value.displayValue.split(":").length == 2
      ) {
        return value.displayValue.split(":")[1].toProperCase();
      }

      return value.displayValue.toProperCase();
    },
    async getDefaultValue() {
      this.advanceFilterModel.DateGroup = "Day";
      this.model.CurrentDateGroup = "Day";
      this.advanceFilterModel.DateIn = new Date();
      await GridReportService.requestData({
        url: "api/ReportCalendar",
        filter: "IsCurrentWeek eq true",
      })
        .then((result) => {
          this.advanceFilterModel.WeekStartDate = result.data.value[0].Code;
          this.model.StartWeekDisplay = result.data.value[0].StartWeek;
        })
        .catch((error) => {
          this.$logger.debug("api/ReportCalendar Error ", error);
        });

      await GridReportService.requestData({
        url: "api/ReportFiscalPeriod",
        filter: "IsCurrentFiscalPeriod eq true",
      })
        .then((result) => {
          this.advanceFilterModel.FiscalPeriodId =
            result.data.value[0].ThisFiscalPeriodId;
          this.advanceFilterModel.QuarterId = result.data.value[0].QuarterId;
        })
        .catch((error) => {
          this.$logger.debug("api/ReportFiscalPeriod Error ", error);
        });

      await GridReportService.requestData({
        url: "api/ReportFiscalYear",
        filter: "IsCurrentYear eq true",
      })
        .then((result) => {
          this.advanceFilterModel.Year = result.data.value[0].Year;
          this.advanceFilterModel.FiscalYear = result.data.value[0].FiscalYear;
        })
        .catch((error) => {
          this.$logger.debug("api/ReportFiscalYear Error ", error);
        });

      this.advanceFilterArray = [];
      await this.setDateFilter(new Date(), "DateIn");
      // await this.setWeekFilter();
      // await this.setMonthFilter(this.advanceFilterModel.FiscalPeriodId);
    },
    async setDateFilter(value, variable) {
      this.serverSideFilter = [];
      let date = new Date(value).toYYYYMMDD();
      let prevDate = new Date(
        new Date(value).getTime() - 7 * 24 * 60 * 60 * 1000
      ).toYYYYMMDD();

      let afilter = [
        ["DateGroup", "=", `${this.advanceFilterModel.DateGroup}`],
        "and",
        [`${variable}`, ">=", new Date(prevDate + "T00:00:00")],
        "and",
        [`${variable}`, "<=", new Date(date + "T00:00:00")],
      ];
      this.serverSideFilter.push(afilter);
    },
    async setWeekFilter() {
      this.serverSideFilter = [];
      let date = new Date(this.model.StartWeekDisplay).toYYYYMMDD();
      let prevDate = new Date(
        new Date(this.model.StartWeekDisplay).getTime() -
          7 * 24 * 60 * 60 * 1000 * 8
      ).toYYYYMMDD();

      let afilter = [
        ["DateGroup", "=", `${this.advanceFilterModel.DateGroup}`],
        "and",
        ["WeekStartDate", ">=", new Date(prevDate + "T00:00:00")],
        "and",
        ["WeekStartDate", "<=", new Date(date + "T00:00:00")],
      ];
      this.serverSideFilter.push(afilter);
    },
    async setMonthFilter(value) {
      this.serverSideFilter = [];
      let afilter = [
        ["DateGroup", "=", `${this.advanceFilterModel.DateGroup}`],
        "and",
        [
          ["FiscalPeriodId", ">=", value - 100],
          "and",
          ["FiscalPeriodId", "<=", value],
        ],
      ];
      this.serverSideFilter.push(afilter);
    },
    async setQuarterFilter(value) {
      this.serverSideFilter = [];
      let afilter = [
        ["DateGroup", "=", `${this.advanceFilterModel.DateGroup}`],
        "and",
        [["QuarterId", ">=", value - 100], "and", ["QuarterId", "<=", value]],
      ];
      this.serverSideFilter.push(afilter);
    },
    async setYearFilter(value, dataField) {
      this.serverSideFilter = [];
      let afilter = [
        ["DateGroup", "=", `${this.advanceFilterModel.DateGroup}`],
        "and",
        [[dataField, ">=", value - 3], "and", [dataField, "<=", value]],
      ];
      this.serverSideFilter.push(afilter);
    },
    async getReportData(filterCollection) {
      let ds = GridReportService.dataSourceConfig(this.apiRouteUrl["url"], {
        count: true,
        preventPagination: true,
        filter: this.serverSideFilter,
      });
      if (this.applyServerFilter) {
        // this.loadingCompleted = false;
        await ds.load();
        this.dataSourceConfig = ds.items();
        this.applyServerFilter = false;
      }

      if (this.$refs["grid-report-grid"]) {
        let grid = this.$refs["grid-report-grid"].instance;
        if (filterCollection.length != 0) {
          grid.filter(filterCollection);
          grid.refresh(true);
        } else {
          grid.clearFilter();
          grid.refresh(true);
        }
      }
      this.showLoading(false);
      this.loadingCompleted = true;

      this.model.CurrentDateGroup = this.advanceFilterModel.DateGroup;
    },
    listContentReady(e) {
      // this.filterFormHeight =
      //   document.getElementsByClassName("dx-datagrid dx-gridbase-container")[0]
      //     .clientHeight -
      //   document.getElementsByClassName("dx-datagrid-header-panel")[0]
      //     .clientHeight -
      //   30;

      this.addGridNoResults(e);

      let grid = e.component.instance();
      grid.off("contentReady");
      grid.repaint(true);
      setTimeout(() => {
        grid.on("contentReady", this.onContentReady);
      }, 1500);
    },
    async createFilterArray(filterCollection, filterField, e) {
      if (filterField == "DateGroup") {
        if (e.value == "Day") {
          await this.setDateFilter(this.advanceFilterModel.DateIn, "DateIn");
        } else if (e.value == "Week") {
          this.setWeekFilter();
        } else if (e.value == "Month") {
          await this.setMonthFilter(this.advanceFilterModel.FiscalPeriodId);
        } else if (e.value == "Quarter") {
          await this.setQuarterFilter(this.advanceFilterModel.QuarterId);
        } else if (e.value == "Calendar Year") {
          await this.setYearFilter(this.advanceFilterModel.Year, "Year");
        } else if (e.value == "Fiscal Year") {
          await this.setYearFilter(
            this.advanceFilterModel.FiscalYear,
            "FiscalYear"
          );
        }
        this.applyServerFilter = true;
      }

      if (filterField == "DateIn") {
        this.applyServerFilter = true;
        await this.setDateFilter(e.value, "DateIn");
      } else if (filterField == "WeekStartDate") {
        this.applyServerFilter = true;
        // this.setWeekFilter();
      } else if (filterField == "FiscalPeriodId") {
        this.applyServerFilter = true;
        await this.setMonthFilter(e.value);
      } else if (filterField == "QuarterId") {
        this.applyServerFilter = true;
        await this.setQuarterFilter(e.value);
      } else if (filterField == "Year") {
        this.applyServerFilter = true;
        await this.setYearFilter(e.value, "Year");
      } else if (filterField == "FiscalYear") {
        this.applyServerFilter = true;
        await this.setYearFilter(e.value, "FiscalYear");
      } else {
        if (
          filterCollection.length == 0 &&
          filterField != "DateGroup" &&
          filterField == undefined
        ) {
          await this.getDefaultValue();
        } else {
          this.showLoading(false);
        }
      }
    },
    async applyFilter(type, filterCollection) {
      this.showLoading(true);
      if (type == "clear") {
        this.applyServerFilter = true;
        await this.getDefaultValue();
      }
      if (this.filterDirty.isDirty == false) {
        this.applyServerFilter = true;
      }
      this.getReportData(filterCollection);
      this.filterDirty.isDirty = false;
    },
    onToolbarPreparing(e) {
      var toolbarItems = e.toolbarOptions.items;
      var searchPanel = toolbarItems.find((item) => {
        return item.name === "searchPanel";
      });
      var exportButton = toolbarItems.find((item) => {
        return item.name === "exportButton";
      });
      var columnChooserButton = toolbarItems.find((item) => {
        return item.name === "columnChooserButton";
      });
      e.toolbarOptions.items = toolbarItems.filter((item) => {
        return (
          item.name !== "searchPanel" &&
          item.name !== "exportButton" &&
          item.name !== "columnChooserButton"
        );
      });
      searchPanel.location = "after";
      e.toolbarOptions.items.unshift(
        searchPanel,
        exportButton,
        columnChooserButton,
        {
          location: "after",
          locateinmenu: "auto",
          widget: "dxButton",
          options: {
            validationGroup: "formsData",
            icon: "filter",
            visible: !this.showRightContainer,
            elementAttr: { id: "filter-btn" },
            onClick: () => {
              this.showRightContainer = !this.showRightContainer;
              var item = document.getElementById("filter-btn");
              this.$logger.debug("item ", item);
              item.classList.add("dx-state-invisible");
            },
          },
        }
      );
    },
    backButtonFunction() {
      this.$router.push({
        path: "/reports/sales",
      });
    },
    setWeekStartDate(e) {
      this.model.StartWeekDisplay = e.itemData.StartWeekDisplay;
      this.setWeekFilter();
    },
  },
  computed: {
    getAdvanceFilterModel() {
      return this.advanceFilterModel;
    },
    filterFormItems() {
      return [
        {
          itemType: "group",
          caption: "",
          colCount: 1,
          items: this.parseFormColumns([
            {
              dataField: "DateGroup",
              gcType: "String",
              editorType: "dxSelectBox",
              gcLabel: "Date",
              editorOptions: {
                itemTemplate: "date-group-items",
                editorType: "dxSelectBox",
                items: [
                  {
                    text: "Daily",
                    secondaryText: "last 7 days",
                    value: "Day",
                    selected: true,
                  },
                  {
                    text: "Weekly",
                    secondaryText: "past 8 weeks (9 including this week)",
                    value: "Week",
                    selected: false,
                  },
                  {
                    text: "Monthly",
                    secondaryText: "past 12 months (13 including this month)",
                    value: "Month",
                    selected: false,
                  },
                  {
                    text: "Quarterly",
                    secondaryText: "past 12 months (inc current quarter)",
                    value: "Quarter",
                    selected: false,
                  },
                  {
                    text: "Yearly",
                    secondaryText: "last 3 years",
                    value: "Calendar Year",
                    selected: false,
                  },
                  {
                    text: "Fiscal Yearly",
                    secondaryText: "last 3 years",
                    value: "Fiscal Year",
                    selected: false,
                  },
                ],
                valueExpr: "value",
                displayExpr: "text",
                filterCode: "DateGroup",
                deferRendering: false,
                onInitialized: (e) => {
                  e.component.beginUpdate();
                  if (!this.advanceFilterModel.DateGroup)
                    e.component.option("value", "Day");
                  e.component.endUpdate();
                },
              },
            },
            {
              dataField: "DateIn",
              gcType: "Date",
              editorType: "DxDateBox",
              gcLabel: "Date In",
              visible: this.advanceFilterModel["DateGroup"] == "Day",
              editorOptions: {
                editorType: "DxDateBox",
                filterCode: "DateIn",
              },
            },
            {
              dataField: "WeekStartDate",
              gcType: "String",
              editorType: "dxSelectBox",
              gcLabel: "Week",
              visible: this.advanceFilterModel["DateGroup"] == "Week",
              editorOptions: {
                dataSource: GridReportService.dataSourceConfig(
                  "api/ReportCalendar",
                  {}
                ),
                valueExpr: "Code",
                displayExpr: "StartWeekDisplay",
                searchMode: "contains",
                deferRendering: false,
                searchEnabled: true,
                onItemClick: (e) => {
                  this.setWeekStartDate(e);
                },
              },
            },
            {
              dataField: "FiscalPeriodId",
              gcType: "String",
              editorType: "dxSelectBox",
              gcLabel: "Month",
              visible: this.advanceFilterModel["DateGroup"] == "Month",
              editorOptions: {
                dataSource: GridReportService.dataSourceConfig(
                  "api/ReportFiscalPeriod",
                  {}
                ),
                valueExpr: "ThisFiscalPeriodId",
                displayExpr: function(data) {
                  if (data)
                    return data.Month.toProperCase() + " " + data.FiscalYear;
                },
                searchMode: "contains",
                searchEnabled: true,
              },
            },
            {
              dataField: "QuarterId",
              gcType: "String",
              editorType: "dxSelectBox",
              gcLabel: "Quarter",
              visible: this.advanceFilterModel["DateGroup"] == "Quarter",
              editorOptions: {
                dataSource: GridReportService.dataSourceConfig(
                  "api/ReportFiscalPeriod",
                  {}
                ),
                valueExpr: "QuarterId",
                displayExpr: function(data) {
                  if (data) return data.QuarterDisplay.toProperCase();
                },
                searchMode: "contains",
                searchEnabled: true,
              },
            },
            {
              dataField: "Year",
              gcType: "String",
              editorType: "dxSelectBox",
              gcLabel: "Calendar Year",
              visible: this.advanceFilterModel["DateGroup"] == "Calendar Year",
              editorOptions: {
                dataSource: GridReportService.dataSourceConfig(
                  "api/ReportFiscalYear",
                  {}
                ),
                valueExpr: "Year",
                displayExpr: "Year",
                searchMode: "contains",
                searchEnabled: true,
              },
            },
            {
              dataField: "FiscalYear",
              gcType: "String",
              editorType: "dxSelectBox",
              gcLabel: "Fiscal Year",
              visible: this.advanceFilterModel["DateGroup"] == "Fiscal Year",
              editorOptions: {
                dataSource: GridReportService.dataSourceConfig(
                  "api/ReportFiscalYear",
                  {}
                ),
                valueExpr: "FiscalYear",
                displayExpr: "FiscalYear",
                searchMode: "contains",
                searchEnabled: true,
              },
            },
            {
              dataField: "SalesRepresentativeCode",
              gcType: "String",
              editorType: "dxTagBox",
              gcLabel: "Order Rep",
              editorOptions: {
                dataSource: GridReportService.dataSourceConfig(
                  "api/SalesRepresentative",
                  {
                    select: ["Code", "FirstName", "Surname"],
                    filter: [
                      ["Inactive", "=", "N"],
                      ["Status", "=", "A"],
                    ],
                  }
                ),
                valueExpr: "Code",
                displayExpr: function(data) {
                  if (data) return data.FirstName + " " + data.Surname;
                },
                searchMode: "contains",
                itemTemplate: "rep-item-template",
                searchEnabled: true,
              },
            },
            {
              dataField: "CustomerSalesRepresentativeCode",
              gcType: "String",
              editorType: "dxTagBox",
              gcLabel: "Customer Rep",
              editorOptions: {
                dataSource: GridReportService.dataSourceConfig(
                  "api/SalesRepresentative",
                  {
                    select: ["Code", "FirstName", "Surname"],
                    filter: [
                      ["Inactive", "=", "N"],
                      ["Status", "=", "A"],
                    ],
                  }
                ),
                valueExpr: "Code",
                displayExpr: function(data) {
                  if (data) return data.FirstName + " " + data.Surname;
                },
                searchMode: "contains",
                itemTemplate: "rep-item-template",
                searchEnabled: true,
              },
            },
            {
              dataField: "CustomerGroupCode",
              gcType: "String",
              editorType: "dxTagBox",
              gcLabel: "Customer Group",
              editorOptions: {
                dataSource: GridReportService.dataSourceConfig(
                  "api/CustomerGroup",
                  {
                    filter: [["Inactive", "=", "N"]],
                    sort: [{ selector: "Description", asc: true }],
                  }
                ),
                valueExpr: "Code",
                displayExpr: "Description",
                searchExpr: ["Code", "Description"],
                searchMode: "contains",
                searchEnabled: true,
                itemTemplate: "item-template",
              },
            },
            {
              dataField: "CustomerTypeCode",
              gcType: "String",
              editorType: "dxTagBox",
              gcLabel: "Customer Type",
              editorOptions: {
                dataSource: GridReportService.dataSourceConfig(
                  "api/CustomerType",
                  {
                    filter: [["Inactive", "=", "N"]],
                    sort: [{ selector: "Description", asc: true }],
                  }
                ),
                valueExpr: "Code",
                displayExpr: "Description",
                searchExpr: ["Code", "Description"],
                searchMode: "contains",
                searchEnabled: true,
                itemTemplate: "item-template",
              },
            },
            {
              dataField: "BranchCode",
              gcType: "String",
              editorType: "dxTagBox",
              gcLabel: "Branch",
              editorOptions: {
                dataSource: GridReportService.dataSourceConfig("api/Branch", {
                  filter: [["Inactive", "=", "N"]],
                  sort: [{ selector: "Description", asc: true }],
                }),
                valueExpr: "Code",
                displayExpr: "Description",
                searchExpr: ["Code", "Description"],
                searchMode: "contains",
                searchEnabled: true,
                itemTemplate: "item-template",
              },
            },
            {
              dataField: "ProductTypeCode",
              gcType: "String",
              editorType: "dxTagBox",
              gcLabel: "Product Type",
              editorOptions: {
                dataSource: GridReportService.dataSourceConfig(
                  "api/ProductType",
                  {
                    filter: [["Inactive", "=", "N"]],
                    sort: [{ selector: "Description", asc: true }],
                  }
                ),
                valueExpr: "Code",
                displayExpr: "Description",
                searchExpr: ["Code", "Description"],
                searchMode: "contains",
                searchEnabled: true,
                itemTemplate: "item-template",
              },
            },
            {
              dataField: "ProductCategory1Code",
              gcType: "String",
              editorType: "dxTagBox",
              gcLabel: "Product Category 1",
              editorOptions: {
                dataSource: GridReportService.dataSourceConfig(
                  "api/ProductCategory1",
                  {
                    filter: [["Inactive", "=", "N"]],
                    sort: [{ selector: "Description", asc: true }],
                  }
                ),
                valueExpr: "Code",
                displayExpr: "Description",
                searchExpr: ["Code", "Description"],
                searchMode: "contains",
                searchEnabled: true,
                itemTemplate: "item-template",
              },
            },
            {
              dataField: "ProductCategory2Code",
              gcType: "String",
              editorType: "dxTagBox",
              gcLabel: "Product Category 2",
              editorOptions: {
                dataSource: GridReportService.dataSourceConfig(
                  "api/ProductCategory2",
                  {
                    filter: [["Inactive", "=", "N"]],
                    sort: [{ selector: "Description", asc: true }],
                  }
                ),
                valueExpr: "Code",
                displayExpr: "Description",
                searchExpr: ["Code", "Description"],
                searchMode: "contains",
                searchEnabled: true,
                itemTemplate: "item-template",
              },
            },
            {
              dataField: "ProductCategory3Code",
              gcType: "String",
              editorType: "dxTagBox",
              gcLabel: "Product Category 3",
              editorOptions: {
                dataSource: GridReportService.dataSourceConfig(
                  "api/ProductCategory3",
                  {
                    filter: [["Inactive", "=", "N"]],
                    sort: [{ selector: "Description", asc: true }],
                  }
                ),
                valueExpr: "Code",
                displayExpr: "Description",
                searchExpr: ["Code", "Description"],
                searchMode: "contains",
                searchEnabled: true,
                itemTemplate: "item-template",
              },
            },
            {
              dataField: "ProductCategory4Code",
              gcType: "String",
              editorType: "dxTagBox",
              gcLabel: "Product Category 4",
              editorOptions: {
                dataSource: GridReportService.dataSourceConfig(
                  "api/ProductCategory4",
                  {
                    filter: [["Inactive", "=", "N"]],
                    sort: [{ selector: "Description", asc: true }],
                  }
                ),
                valueExpr: "Code",
                displayExpr: "Description",
                searchExpr: ["Code", "Description"],
                searchMode: "contains",
                searchEnabled: true,
                itemTemplate: "item-template",
              },
            },
            {
              dataField: "ItemCode",
              gcType: "String",
              editorType: "dxTagBox",
              gcLabel: "Items",
              editorOptions: {
                dataSource: GridReportService.dataSourceConfig(
                  "api/ProductList",
                  {
                    filter: [["Inactive", "=", "N"]],
                    sort: [{ selector: "Description1", asc: true }],
                  }
                ),
                valueExpr: "Code",
                displayExpr: "Description1",
                searchExpr: ["Code", "Description1"],
                searchMode: "contains",
                searchEnabled: true,
                itemTemplate: "product-item-template",
              },
            },
          ]),
        },
      ];
    },
    columnSummaryWithColumns() {
      return this.columnSummary.filter((x) => x["summary-type"] != "custom");
    },
    columnSummaryCustom() {
      return this.columnSummary.filter((x) => x["summary-type"] == "custom");
    },
    columnSummary() {
      return [
        {
          id: 1,
          column: "Quantity",
          name: "Quantity",
          "summary-type": "sum",
          "value-format": this.getDecimalFormatByName("Decimal-4-2-RO").Format,
          "display-format": "{0}",
          "show-in-group-footer": false,
          "align-by-column": true,
          "show-in-column": "ItemQty",
        },
        {
          id: 2,
          column: this.getLabelWithCurrencyCode("Ex Tax"),
          name: "ex-tax",
          "summary-type": "sum",
          "value-format": this.getDecimalFormatByName("Decimal-4-2C-RO").Format,
          "display-format": "{0}",
          "show-in-group-footer": false,
          "align-by-column": true,
          "show-in-column": "SalesExTax",
        },
        {
          id: 3,
          column: this.getLabelWithCurrencyCode("Cost"),
          name: "cost",
          "summary-type": "sum",
          "value-format": this.getDecimalFormatByName("Decimal-4-2C-RO").Format,
          "display-format": "{0}",
          "show-in-group-footer": false,
          "align-by-column": true,
          "show-in-column": "TotalCost",
        },
        {
          id: 4,
          column: this.getLabelWithCurrencyCode("GP"),
          name: "gp",
          "summary-type": "sum",
          "value-format": this.getDecimalFormatByName("Decimal-4-2C-RO").Format,
          "display-format": "{0}",
          "show-in-group-footer": false,
          "align-by-column": true,
          "show-in-column": "GrossProfitVal",
        },
        {
          id: 5,
          // column: this.getLabelWithCurrencyCode("GP"),
          name: "gppercent",
          "summary-type": "custom",
          "show-in-group-footer": false,
          "value-format": this.getDecimalFormatByName("Decimal-4-2P").Format,
          "align-by-column": true,
          "show-in-column": "GrossProfitPcnt",
        },
      ];
    },

    columns() {
      return this.parseGridColumns("grouped-report", [
        {
          gcLabel: "Date",
          dataField: "DateGroupDisplay",
          gcType: "String",
          width: 200,
          sortOrder: "desc",
          allowHiding: false,
          groupIndex: "0",
          cellTemplate: "dategroupdisplay-cell-template",
          groupCellTemplate: "group-dategroupdisplay-cell-template",
          // calculateGroupValue: (e) => {
          //   console.log('header value ', e);
          //   return e.DateGroupDisplay;
          // }
        },
        {
          gcLabel: "Customer Group",
          dataField: "CustomerGroupDescription",
          gcType: "String",
          width: 220,
          sortOrder: "asc",
          cellTemplate: "customer-group-cell-template",
          groupCellTemplate: "groupHeaderTemplate",
          gcExport: ["CustomerGroupCode", "CustomerGroupDescription"],
        },
        {
          gcLabel: "Customer Type",
          dataField: "CustomerTypeDescription",
          gcType: "String",
          minWidth: this.gridColumnMinWidth(300),
          cellTemplate: "customer-type-cell-template",
          gcSubType: "HiddenDescription",
          groupCellTemplate: "groupHeaderTemplate",
          gcExport: ["CustomerTypeCode", "CustomerTypeDescription"],
        },
        {
          gcLabel: "Customer",
          dataField: "CustomerName",
          gcType: "String",
          width: 220,
          sortOrder: "asc",
          cellTemplate: "customer-cell-template",
          groupIndex: "1",
          groupCellTemplate: "groupHeaderTemplate",
          gcExport: ["CustomerCode", "CustomerName"],
        },
        {
          gcLabel: "Branch",
          dataField: "BranchDescription",
          gcType: "String",
          width: 220,
          cellTemplate: "branch-cell-template",
          gcSubType: "HiddenDescription",
          groupCellTemplate: "groupHeaderTemplate",
          gcExport: ["BranchCode", "BranchDescription"],
        },
        {
          gcLabel: "Category 1",
          dataField: "ProductCategory1Description",
          gcType: "String",
          width: 220,
          cellTemplate: "category-1-cell-template",
          gcSubType: "HiddenDescription",
          groupCellTemplate: "groupHeaderTemplate",
          gcExport: ["ProductCategory1Code", "ProductCategory1Description"],
        },
        {
          gcLabel: "Category 2",
          dataField: "ProductCategory2Description",
          gcType: "String",
          width: 220,
          sortOrder: "asc",
          cellTemplate: "category-2-cell-template",
          groupCellTemplate: "groupHeaderTemplate",
          gcExport: ["ProductCategory2Code", "ProductCategory2Description"],
        },
        {
          gcLabel: "Category 3",
          dataField: "ProductCategory3Description",
          gcType: "String",
          width: 220,
          cellTemplate: "category-3-cell-template",
          gcSubType: "HiddenDescription",
          groupCellTemplate: "groupHeaderTemplate",
          gcExport: ["ProductCategory3Code", "ProductCategory3Description"],
        },
        {
          gcLabel: "Category 4",
          dataField: "ProductCategory4Description",
          gcType: "String",
          width: 220,
          cellTemplate: "category-4-cell-template",
          gcSubType: "HiddenDescription",
          groupCellTemplate: "groupHeaderTemplate",
          gcExport: ["ProductCategory4Code", "ProductCategory4Description"],
        },
        {
          gcLabel: "Product Type",
          dataField: "ProductTypeDescription",
          gcType: "String",
          width: 220,
          cellTemplate: "product-type-cell-template",
          gcSubType: "HiddenDescription",
          groupCellTemplate: "groupHeaderTemplate",
          gcExport: ["ProductTypeCode", "ProductTypeDescription"],
        },
        {
          gcLabel: "Product Size",
          dataField: "ProductSizeDescription",
          gcType: "String",
          width: 220,
          cellTemplate: "product-size-cell-template",
          gcSubType: "HiddenDescription",
          groupCellTemplate: "groupHeaderTemplate",
          gcExport: ["ProductSizeCode", "ProductSizeDescription"],
        },
        {
          gcLabel: "Order Rep",
          dataField: "SalesRepresentativeCode",
          width: 200,
          gcType: "String",
          cellTemplate: "sales-rep-cell-template",
          gcSubType: "HiddenDescription",
          groupCellTemplate: "groupHeaderTemplate",
          gcExport: ["SalesRepresentativeCode", "SalesRepresentativeFullName"],
        },
        {
          gcLabel: "Customer Rep",
          dataField: "CustomerSalesRepresentativeCode",
          width: 200,
          gcType: "String",
          cellTemplate: "customer-rep-cell-template",
          gcSubType: "HiddenDescription",
          groupCellTemplate: "groupHeaderTemplate",
          gcExport: [
            "CustomerSalesRepresentativeCode",
            "CustomerSalesRepresentativeFullName",
          ],
        },
        {
          gcLabel: "Item",
          dataField: "ItemDescription1",
          gcType: "String",
          width: 220,
          sortOrder: "asc",
          cellTemplate: "item-cell-template",
          groupCellTemplate: "groupHeaderTemplate",
          gcExport: ["ItemCode", "ItemDescription1"],
        },
        {
          gcLabel: "Quantity",
          dataField: "ItemQty",
          gcType: "Decimal-4-2-RO",
          cellTemplate: "number-cell-template",
        },
        {
          gcDynamicLabel: this.getLabelWithCurrencyCode("Ex Tax"),
          dataField: "SalesExTax",
          gcType: "Decimal-4-2C-RO",
          allowResizing: false,
          cellTemplate: "number-cell-template",
        },
        {
          gcDynamicLabel: this.getLabelWithCurrencyCode("Cost"),
          dataField: "TotalCost",
          gcType: "Decimal-4-2C-RO",
          allowResizing: false,
          cellTemplate: "number-cell-template",
        },
        {
          gcDynamicLabel: this.getLabelWithCurrencyCode("GP"),
          dataField: "GrossProfitVal",
          gcType: "Decimal-4-2C-RO",
          allowResizing: false,
          cellTemplate: "number-cell-template",
        },
        {
          gcLabel: "GP",
          dataField: "GrossProfitPcnt",
          gcType: "Decimal-4-2P",
          allowResizing: false,
          cellTemplate: "number-cell-template",
        },
        {
          gcLabel: "Order Rep Code",
          dataField: "SalesRepresentativeCode",
          width: 150,
          gcType: "String",
          gcSubType: "HiddenDescription",
          groupCellTemplate: "groupHeaderTemplate",
        },
        {
          gcLabel: "Order Rep Name",
          dataField: "SalesRepresentativeFullName",
          width: 200,
          gcType: "String",
          gcSubType: "HiddenDescription",
          groupCellTemplate: "groupHeaderTemplate",
        },
        {
          gcLabel: "Customer Rep Code",
          dataField: "CustomerSalesRepresentativeCode",
          width: 150,
          gcType: "String",
          gcSubType: "HiddenDescription",
          groupCellTemplate: "groupHeaderTemplate",
        },
        {
          gcLabel: "Customer Rep Name",
          dataField: "CustomerSalesRepresentativeFullName",
          width: 200,
          gcType: "String",
          gcSubType: "HiddenDescription",
          groupCellTemplate: "groupHeaderTemplate",
        },
        {
          gcLabel: "Customer Group Code",
          dataField: "CustomerGroupCode",
          width: 200,
          gcType: "String",
          gcSubType: "HiddenDescription",
          groupCellTemplate: "groupHeaderTemplate",
        },
        {
          gcLabel: "Customer Group Description",
          dataField: "CustomerGroupDescription",
          width: 200,
          gcType: "String",
          gcSubType: "HiddenDescription",
          groupCellTemplate: "groupHeaderTemplate",
        },
        {
          gcLabel: "Customer Type Code",
          dataField: "CustomerTypeCode",
          width: 200,
          gcType: "String",
          gcSubType: "HiddenDescription",
          groupCellTemplate: "groupHeaderTemplate",
        },
        {
          gcLabel: "Customer Type Description",
          dataField: "CustomerTypeDescription",
          width: 200,
          gcType: "String",
          gcSubType: "HiddenDescription",
          groupCellTemplate: "groupHeaderTemplate",
        },
        {
          gcLabel: "Customer Code",
          dataField: "CustomerCode",
          width: 200,
          gcType: "String",
          gcSubType: "HiddenDescription",
          groupCellTemplate: "groupHeaderTemplate",
        },
        {
          gcLabel: "Customer Name",
          dataField: "CustomerName",
          width: 200,
          gcType: "String",
          gcSubType: "HiddenDescription",
          groupCellTemplate: "groupHeaderTemplate",
        },
        {
          gcLabel: "Branch Code",
          dataField: "BranchCode",
          width: 200,
          gcType: "String",
          gcSubType: "HiddenDescription",
          groupCellTemplate: "groupHeaderTemplate",
        },
        {
          gcLabel: "Branch Name",
          dataField: "BranchDescription",
          width: 200,
          gcType: "String",
          gcSubType: "HiddenDescription",
          groupCellTemplate: "groupHeaderTemplate",
        },
        {
          gcLabel: "Category 1 Code",
          dataField: "ProductCategory1Code",
          width: 200,
          gcType: "String",
          gcSubType: "HiddenDescription",
          groupCellTemplate: "groupHeaderTemplate",
        },
        {
          gcLabel: "Category 1 Description",
          dataField: "ProductCategory1Description",
          width: 200,
          gcType: "String",
          gcSubType: "HiddenDescription",
          groupCellTemplate: "groupHeaderTemplate",
        },
        {
          gcLabel: "Category 2 Code",
          dataField: "ProductCategory2Code",
          width: 200,
          gcType: "String",
          gcSubType: "HiddenDescription",
          groupCellTemplate: "groupHeaderTemplate",
        },
        {
          gcLabel: "Category 2 Description",
          dataField: "ProductCategory2Description",
          width: 200,
          gcType: "String",
          gcSubType: "HiddenDescription",
          groupCellTemplate: "groupHeaderTemplate",
        },
        {
          gcLabel: "Category 3 Code",
          dataField: "ProductCategory3Code",
          width: 200,
          gcType: "String",
          gcSubType: "HiddenDescription",
          groupCellTemplate: "groupHeaderTemplate",
        },
        {
          gcLabel: "Category 3 Description",
          dataField: "ProductCategory3Description",
          width: 200,
          gcType: "String",
          gcSubType: "HiddenDescription",
          groupCellTemplate: "groupHeaderTemplate",
        },
        {
          gcLabel: "Category 4 Code",
          dataField: "ProductCategory4Code",
          width: 200,
          gcType: "String",
          gcSubType: "HiddenDescription",
          groupCellTemplate: "groupHeaderTemplate",
        },
        {
          gcLabel: "Category 4 Description",
          dataField: "ProductCategory4Description",
          width: 200,
          gcType: "String",
          gcSubType: "HiddenDescription",
          groupCellTemplate: "groupHeaderTemplate",
        },
        {
          gcLabel: "Product Type Code",
          dataField: "ProductTypeCode",
          width: 200,
          gcType: "String",
          gcSubType: "HiddenDescription",
          groupCellTemplate: "groupHeaderTemplate",
        },
        {
          gcLabel: "Product Type Description",
          dataField: "ProductTypeDescription",
          width: 200,
          gcType: "String",
          gcSubType: "HiddenDescription",
          groupCellTemplate: "groupHeaderTemplate",
        },
        {
          gcLabel: "Product Size Code",
          dataField: "ProductSizeCode",
          width: 150,
          gcType: "String",
          gcSubType: "HiddenDescription",
          groupCellTemplate: "groupHeaderTemplate",
        },
        {
          gcLabel: "Product Size Description",
          dataField: "ProductSizeDescription",
          width: 200,
          gcType: "String",
          gcSubType: "HiddenDescription",
          groupCellTemplate: "groupHeaderTemplate",
        },
        {
          gcLabel: "Item Code",
          dataField: "ItemCode",
          width: 200,
          gcType: "String",
          gcSubType: "HiddenDescription",
          groupCellTemplate: "groupHeaderTemplate",
        },
        {
          gcLabel: "Item Description",
          dataField: "ItemDescription1",
          width: 200,
          gcType: "String",
          gcSubType: "HiddenDescription",
          groupCellTemplate: "groupHeaderTemplate",
        },
        {
          gcLabel: "",
          dataField: "",
          width: 5,
          minWidth: this.gridColumnMinWidth(5),
          gcType: "String",
          allowResizing: false,
          columnMinWidth: 5,
          fixed: true,
          fixedPosition: "right",
          allowExporting: false,
          allowGrouping: false,
          allowHiding: false,
          showInColumnChooser: false,
        },
      ]);
    },
  },
};
</script>
